var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTips(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C3.58 0 0 3.58 0 8C0 12.42 3.58 16 8 16C12.42 16 16 12.42 16 8C16 3.58 12.42 0 8 0ZM8.24 10.89C8.35 10.89 8.6 10.73 8.98 10.4L9.26 10.68C8.78 11.15 8.31 11.52 7.87 11.78C7.43 12.04 7.09 12.18 6.85 12.18C6.61 12.18 6.49 12.08 6.49 11.88C6.49 11.7 6.66 11.11 7.01 10.13L7.43 8.95C7.6 8.5 7.68 8.23 7.68 8.14C7.68 8.04 7.64 7.99 7.57 7.99C7.5 7.99 7.3 8.12 6.97 8.38L6.71 8.06C7.85 7.05 8.63 6.55 9.05 6.55C9.25 6.55 9.35 6.66 9.35 6.88C9.35 6.99 9.28 7.25 9.14 7.68L8.18 10.52C8.15 10.63 8.14 10.71 8.14 10.77C8.14 10.85 8.17 10.89 8.24 10.89ZM9.77 5.3C9.6 5.54 9.39 5.67 9.15 5.67C8.98 5.67 8.83 5.61 8.7 5.49C8.57 5.37 8.51 5.2 8.51 4.97C8.51 4.7 8.59 4.46 8.76 4.23C8.93 4 9.14 3.89 9.4 3.89C9.58 3.89 9.73 3.95 9.85 4.08C9.97 4.21 10.03 4.36 10.03 4.55C10.02 4.81 9.94 5.06 9.77 5.3Z",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTips);
export default __webpack_public_path__ + "static/media/tips.440b891afd29172038a75bbde049263d.svg";
export { ForwardRef as ReactComponent };